import Simplert from './Simplert.js';

export default Simplert;